module.exports = __webpack_public_path__ + "img/125.08203a78.jpg";